<template>
  <div id="swipe-cta-interface">
     
  </div>
</template>


<script>
  
import { mapState, mapMutations } from 'vuex' 
import SwipeService from 'src/services/SwipeService'

import SwipeableUIService from '@/services/SwipeableUIService'

export default {

  name: 'swipe-cta-interface',

  data() {
    return {}
  },

  computed: {
    ...mapState('browser', ['isMobile', 'isTablet'])
  },

  mounted() {

    this.swipeService = new SwipeService();

    this.swipeService.on(SwipeService.Events.Complete, this.onSwipeComplete);
    this.swipeService.on(SwipeService.Events.Progress, this.onSwipeProgress);
    //this.swipeService.on(SwipeService.Events.Set.State, this.onStateChange);
    this.swipeService.on(SwipeService.Events.Set.InputState, this.onInputStateChange);
    this.swipeService.on(SwipeService.Events.Set.Lock, this.onLockChange);

    SwipeableUIService.on("uiShowing", this.onUiUpdate)


    this.$html = document.documentElement;
    this.rootNode = document.getElementById("app");

    this.$headerSwipe = document.createElement("div");
    this.$headerSwipe.style.visibility = 'hidden';
    this.$headerSwipe.style.position = 'relative';
    this.$headerSwipe.style.zIndex = 10;
    this.$headerSwipe.style.width = 1;
    this.$headerSwipe.style.height = 99999999 + 'px';

    this.$html.appendChild(this.$headerSwipe);
  },

  beforeDestroy() { },

  methods: { 

    ...mapMutations('swipeup', [  
      'setShow',
      'setProgress',
      'setState',
      'setLocked',
      'setInputState'
    ]),
    
    onSwipeComplete() {
      this.setShow(false); 
    },

    onSwipeProgress(value) {
      this.setProgress(value); 
    },

    onStateChange(value) { 
      this.setState(value);
    },

    onUiUpdate(uiShowing) { 
      if(uiShowing){
        this.$html.appendChild(this.$headerSwipe);  
      } else {
        if (this.$html.contains(this.$headerSwipe)) {
          this.$html.removeChild(this.$headerSwipe);  
        }
      } 
    },

    onInputStateChange(value) { 
      this.setInputState(value);
    },

    onLockChange(value) { 
      this.setLocked(value);
    } 
  },

  watch: {}

}

</script>


<style lang="sass" >
 
  #swipe-cta-interface
    display: none;
 
</style> 